import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class InternetBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'internetMonthlyBudget',
      accessorFn: value => value.internetOptions?.monthlyBudget,
      header: 'INTERNET.fields.monthlyBudget',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
  ];
}
